<template>
  <div class="px-6">
    <Loader v-if="loading" />
    <v-data-table
      v-else
      :items="history"
      :headers="headers"
      :items-per-page="10"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:[`item.author`]="{ item }">
        {{ item.userName }} {{ item.userSurname }}
      </template>
      <template v-slot:[`item.dateTime`]="{ item }">
        {{ formatDateTime(item.dateTime) }}
      </template>
      <template v-slot:[`item.change`]="{ item }">
        <strong>{{ translateFieldName(item.fieldName) }}:</strong> {{ item.oldValue }} → {{ item.newValue }}
      </template>
      <template v-slot:no-data>
        <div class="text-center py-4 grey--text">
          {{ $t('common.noHistory') }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Service from '@/services'
import Loader from '@/components/Loader'

export default {
  name: 'History',
  components: { Loader },
  props: {
    contractorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      history: [],
      headers: [
        { text: this.$t('tslContractors.history.author'), value: 'author', sortable: false },
        { text: this.$t('tslContractors.history.date'), value: 'dateTime', sortable: false },
        { text: this.$t('tslContractors.history.change'), value: 'change', sortable: false }
      ]
    }
  },
  created () {
    this.loadHistory()
  },
  methods: {
    async loadHistory () {
      this.loading = true
      try {
        const { data } = await Service.get('/TSLContractor/GetHistory', { contractorId: this.contractorId })
        this.history = data || []
      } catch (e) {
        console.error('Error loading history:', e)
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading history')
      } finally {
        this.loading = false
      }
    },
    formatDateTime (dateTime) {
      return new Date(dateTime).toLocaleString()
    },
    translateFieldName (fieldName) {
      const fieldMap = {
        CompanyName: this.$t('tslContractors.companyName'),
        VatNumber: this.$t('tslContractors.vatNumber'),
        Street: this.$t('tslContractors.street'),
        ZipCode: this.$t('tslContractors.zipCode'),
        City: this.$t('tslContractors.city'),
        Country: this.$t('tslContractors.country'),
        Address: this.$t('tslContractors.companyData'),
        FirstName: this.$t('tslContractors.firstName'),
        LastName: this.$t('tslContractors.lastName'),
        Phone: this.$t('tslContractors.phone'),
        Email: this.$t('tslContractors.email'),
        ContactData: this.$t('tslContractors.contactData'),
        InvoiceData: this.$t('tslContractors.invoiceData'),
        Notes: this.$t('tslContractors.notes'),
        PaymentType: this.$t('tslContractors.paymentType'),
        DeferredPaymentDays: this.$t('tslContractors.deferredPaymentDays'),
        CooperationStatus: this.$t('tslContractors.cooperationStatus'),
        DocumentAdded: this.$t('tslContractors.history.documentAdded'),
        DocumentDescription: this.$t('tslContractors.history.documentDescription'),
        DocumentValidDate: this.$t('tslContractors.history.documentValidDate'),
        DocumentValidIndefinitly: this.$t('tslContractors.history.documentValidIndefinitly'),
        DocumentArchived: this.$t('tslContractors.history.documentArchived'),
        NoteAdded: this.$t('tslContractors.history.noteAdded'),
        NoteContent: this.$t('tslContractors.history.noteContent')
      }
      return fieldMap[fieldName] || fieldName
    }
  }
}
</script>
